/* eslint-disable max-len */
import { Component, ElementRef, Input } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';
import { readAndCompressImage } from 'browser-image-resizer';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from '../../services/auth.service';
import { LedgerService } from 'src/app/services/ledger.service';
import firebase from 'firebase/app';
import 'firebase/storage';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss'],
})
export class PostComponent {

  @Input() public small: any;
  @Input() public groupId: any;
  @Input() public squareId: any;

  fullscreen = false;
  privacySettings;
  articleForm;
  loading = false;
  // eslint-disable-next-line max-len
  subjects = ['General', 'Physics', 'Chemistry', 'Biology', 'General Science', 'Maths', 'Hindi', 'English', 'Urdu', 'Sanskrit', 'Language', 'Literature', 'Economics', 'Civics', 'Geography', 'History', 'Arts', 'Law', 'Accounts', 'Business Studies', 'Physical Activities', 'Engineering', 'Medical Science', 'Environmental Science', 'Computer Science', 'Energy Science', 'Pharmacy', 'Product Designing', 'Manufacturing', 'Programming', 'Philosophy', 'Psychology', 'Drawing', 'CAD Designing', 'Thermodynamics', 'Quantum Mechanics', 'Mechanics', 'Sociology', 'Entrepreneurship', 'Mechanical Engineering', 'Electrical Engineering', 'Civil Engineering', 'Statistics', 'Artificial Intelligence', 'Aerospace', 'Others'];
  storage = firebase.storage();
  tfModel;
  tapCount = 0;
  tab = 'post';
  isTaging = false;
  keyword = '';
  tags = [];
  uniqueComponentKey = window?.location?.pathname?.split('/')[1]?.split('/')[0];
  constructor(
    public firestore: AngularFirestore,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
    public el: ElementRef,
    public ledgerService: LedgerService,
  ) {
    this.freshPostForm();
  }

  freshPostForm() {
    this.tags = [];
    this.isTaging = false;
    this.articleForm = this.formBuilder.group({
      content: [undefined],
      question: [undefined],
      questionDetail: [undefined],
      type: [this.tab],
      notes: [undefined],
      notesInfo: [undefined],
      article: [undefined],
      articleCopyRight: [undefined],
      title: [undefined],
      subjects: [undefined],
      images: [undefined],
      files: [undefined],
      privacy: ['public', [Validators.required]],
      published: ['true', [Validators.required]],
    });
    return;
  }

  async addArticle(article) {
    // Add a new document with a generated id.
    article.user = this.authService.currentUser.id;
    const docRef = await this.firestore.collection('articles').add(article);
    console.log('Document written with ID: ', docRef.id);
    this.freshPostForm();
    this.presentToast('Successfully Posted!');
    window.dispatchEvent(new CustomEvent('refresh-articles'));
  }

  segmentChanged(event) {
    this.tab = event.detail.value;
    this.articleForm.reset();
    this.tags = [];
    this.articleForm.controls.type.setValue(this.tab);
    this.articleForm.controls.privacy.setValue('public');
    this.articleForm.controls.published.setValue('true');
  }


  onFocusContent() {
    document.getElementById('post-content').scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  getImage() {
    document.getElementById('image-input' + this.uniqueComponentKey).click();
  }
  getFile() {
    document.getElementById('file-input' + this.uniqueComponentKey).click();
  }
  readFile(event) {
    // window.dispatchEvent(new CustomEvent('loading-start'));
    this.loading = true;
    const imageConfig = {
      quality: 1,
      maxWidth: 1080,
      maxHeight: 1080,
      autoRotate: true,
      debug: false,
      mimeType: 'image/jpeg'
    };
    if (event.target.files && event.target.files[0]) {
      readAndCompressImage(event.target.files[0], imageConfig)
        .then(resizedImage => {
          console.log(resizedImage);
          // eslint-disable-next-line max-len
          const storageRef = this.storage.ref( 'articleImages/' + this.authService.currentUser.uid + '_' + Math.random().toString(36).substring(2, 9));
          // 'file' comes from the Blob or File API
          storageRef.put(resizedImage).then((snapshot) => {
            console.log('Uploaded a blob or file!', snapshot);
            snapshot.ref.getDownloadURL().then((downloadURL) => {
              console.log('File available at', downloadURL);
              let images = this.articleForm.get('images').value;
              if (images && images.length >= 1) {
                images.push(downloadURL);
                this.articleForm.get('images').setValue(images, {
                  onlyself: true
                });
                this.loading = false;
              } else {
                images = [downloadURL];
                this.articleForm.get('images').setValue(images, {
                  onlyself: true
                });
                this.loading = false;
              }
            });
          });
        }).catch(err => {
          console.log(err);
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }

  readDocFile(event) {
    // window.dispatchEvent(new CustomEvent('loading-start'));
    this.loading = true;
    if (event.target.files && event.target.files[0]) {
      console.log(event.target.files[0]);
      // eslint-disable-next-line max-len
      const storageRef = this.storage.ref( 'articleFiles/' + this.authService.currentUser.uid + '_' + Math.random().toString(36).substring(2, 9));
      // 'file' comes from the Blob or File API
      storageRef.put(event.target.files[0]).then((snapshot) => {
        console.log('Uploaded a blob or file!', snapshot);
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log('File available at', downloadURL);
          let files = this.articleForm.get('files').value;
          if (files && files.length >= 1) {
            files.push(downloadURL);
            this.articleForm.get('files').setValue(files);
            this.loading = false;
          } else {
            files = [downloadURL];
            this.articleForm.get('files').setValue(files);
            this.loading = false;
          }
        });
      });
    } else {
      this.loading = false;
    }
  }


  removeImage(image) {
    let images = this.articleForm.get('images').value;
    images = images.filter(img => img !== image);
    this.articleForm.get('images').setValue(images, {
      onlyself: true
    });
  }

  removeFile(file) {
    let files = this.articleForm.get('files').value;
    files = files.filter(fle => fle !== file);
    this.articleForm.get('files').setValue(files, {
      onlyself: true
    });
  }


  setKeyword($event) {
    this.keyword = $event.target.value;
  }

  addTag() {
    console.log(this.keyword);
    if (this.keyword === '') {
      this.presentToast('Enter Some Keyword!');
    } else {
      if (!this.tags.includes(this.keyword)) {
        this.tags.push(this.keyword);
        this.keyword = '';
      } else {
        this.presentToast('Keyword Already Taged!');
      }
    }
  }


  removeTag(i) {
    this.tags.splice(i, 1);
  }

  enableIndexedSearch(str) {
    if (!(str?.length > 0)) {
      return undefined;
    }
    console.log(str);
    const search = [];
    for (let i = 1; i < str.length + 1 && i <=250 ; i++) {
      search.push(str.substring(0, i).toLowerCase());
    }
    return search.length > 0 ? search : undefined;
  }


  async postArticle() {
    this.loading = true;
    console.log(this.articleForm);
    if (this.articleForm.valid) {
      const article = this.articleForm.getRawValue();
      if (article.content || article.question || article.note || article.article || article.title || article.notesInfo) {
        const coinCost = { post: -1, question: -5, note: 10, article: 20 };
        article.uid = this.authService.currentUser.uid;
        article.groupId = this.groupId;
        article.squareId = this.squareId;
        article.timestamp = Date.now();
        article.tags = this.tags;

        article.search = [];
        ['question', 'content', 'article', 'title', 'notesInfo', 'questionDetail', 'notes'].forEach(elem => {
          console.log(article[elem]);
          if (article[elem]) {
            article.search = [...article.search, ...this.enableIndexedSearch(article[elem])];
          }
        });
        article.tags.forEach(element => {
          console.log(element);
          article.search = [...article.search, ...this.enableIndexedSearch(element)];
        });
        article?.subjects?.forEach(element => {
          console.log(element);
          article.search = [...article.search, ...this.enableIndexedSearch(element)];
        });
        Object.keys(article).forEach(key => article[key] === undefined || article[key] === null ? delete article[key] : {});
        console.log(article);


        await this.addArticle(article);
        this.ledgerService.addUserLedger({ user: this.authService.currentUser.id, message: 'Sharing Reward/Cost!', value: coinCost[article.type] });
        this.loading = false;
      }
      else {
        this.presentToast('Please Post Something Valid!');
        this.loading = false;
      }
    } else {
      this.presentToast('Please Post Something Valid!');
      this.loading = false;
    }
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  onFocusSmallGoBigBtn() {
    this.small = false;
    setTimeout(() => {
      this.el?.nativeElement?.querySelector('[formcontrolname="newcontent"]')?.focus();
    }, 500);
  }


}
